import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AuthService} from '../../auth/services/auth.service';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../../environments/environment';
import {Delegation} from '../../model/delegation';
import {DelegationRequestModel} from './delegation.model';
import {Router} from '@angular/router';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class DelegationService {
  constructor(private http: HttpClient, private auth: AuthService,private router: Router) {
  }

  selectAllHabilitationsSubject$ = new BehaviorSubject<boolean>(false);
  selectHabilitationItemSubject$ = new BehaviorSubject<boolean>(false);

  loadAllDelegation(matricule:string):Observable<any>{
    if(!localStorage.getItem("SITES") || localStorage.getItem("SITES") == 'null')
      return this.http.get<any>(environment.api.mscore+`management/delegates/${matricule}`);
    else {
      let sites = localStorage.getItem("SITES")
      return this.http.get<any>(environment.api.mscore+`management/delegates/site?namesite=${sites}`);
    }
  }

  saveDelegation(payload: Delegation[], matricule: string) {
    return this.http.post(environment.api.myshiftUrl + `/delegationHab/bulkSave?username=${matricule}`, payload);
  }

  getDelegations(matricule: string,showOldDelegation:boolean,page:number,size:number):Observable<any> {
    return this.http.post<any>(environment.api.myshiftUrl + `/delegationHab/getDelegationsByPage?page=${page}&size=${size}`, {
      dirSite:matricule,
      passed:showOldDelegation
    });
  /*  return this.http.post<DelegationList[]>(environment.api.myshiftUrl + `/delegationHab/getDelegations`, {
      dirSite:matricule,
      passed:showOldDelegation
    });*/
  }
  saveBulkDelegation(matricule: string, delegations: DelegationRequestModel[]): Observable<any> {
    return this.http.post(environment.api.myshiftUrl + `/delegationHab/bulkSave?username=${matricule}`, delegations
    );
  }

  deleteDelegation(delegationDeletedId: number, matricule: string) {
    return this.http.post(environment.api.myshiftUrl + `/delegationHab/delete?idDelegation=${delegationDeletedId}&username=${matricule}`,
      {}
    );
  }

  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri]));
  }

  getDelegationHabilitationParams() {
    return this.http.get<any>(environment.api.myshiftUrl +`/delegationHabilitationParams/all`);
  }

  totalDelegationsExpiringSoon(matricule: string) {
    return this.http.get<any>(environment.api.myshiftUrl +`/delegationHab/expiredSoon?username=${matricule}`);
  }
  totalInjectionsPending():Observable<any> {
    return this.http.post(environment.api.myshiftUrl +`/injection/v2/count`, this.auth.listDelegation);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/delegation/delegation.service.ts